import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import axios from "axios"
import { RootState } from "."
import {
    SolarProductionState,
    SolarProductionResponse,
    SolarProductionMeasurements,
} from "@/types/solar-production"

const state: SolarProductionState = {
    measurements: null,
    loading: false,
    error: null,
}

const mutations: MutationTree<SolarProductionState> = {
    SET_LOADING(state, loading: boolean) {
        state.loading = loading
    },
    SET_MEASUREMENTS(state, measurements: SolarProductionMeasurements) {
        state.measurements = measurements
    },
    SET_ERROR(state, error: string | null) {
        state.error = error
    },
}

const actions: ActionTree<SolarProductionState, RootState> = {
    async fetchSolarProduction({ commit }, locationId: number) {
        commit("SET_LOADING", true)
        commit("SET_ERROR", null)

        try {
            const response = await axios.get<SolarProductionResponse>(
                `/locations/${locationId}/data/energy/solar`,
            )
            commit("SET_MEASUREMENTS", response.data.data.measurements)
        } catch (error: any) {
            commit("SET_ERROR", error.message || "Failed to fetch solar production data")
        } finally {
            commit("SET_LOADING", false)
        }
    },
}

const getters: GetterTree<SolarProductionState, RootState> = {
    measurements: (state) => state.measurements,
    loading: (state) => state.loading,
    error: (state) => state.error,
}

const SolarProductionModule: Module<SolarProductionState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default SolarProductionModule
